<template>
  <div class="company--contacts-tab--details">
    <todo-tasks :companyId="companyId" :contactId="contactId" :salesRep="company.salesPerson1UserId" :companyName="company.name" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import TodoTasks from '@/shared/components/TodoTasks';

  export default {
    components: {
      TodoTasks
    },
    name: 'ContactTabTasks',
    data() {
      return {
        
      };
    },
    computed: {
      ...mapGetters('companies', ['companyById']),
      company() {
        return this.companyById(this.companyId);
      },
      companyId() {
        return this.$route.params.id;
      },
      contactId() {
        return this.$route.params.contactId;
      },
    },
    validations: {
    },
    methods: {
    },
    watch: {
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_colors.scss';

  .phone-input {
    width: 70%;
    float: left;
    margin-right: 5px;
  }

  .phone-type-input {
    width: 100%;
  }

  .contact {
    &--title {
      color: $mutedGray;
      font-weight: bold;
      font-size: 16px;
      margin-left: 15px;
    }
  }

  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 50%;
    z-index: 7;
  }

  .cancelButton {
    margin-right: 10px;
  }
</style>
